import { setComponentMapOverrides } from '@jutro/uiconfig';
import FNOLNonAutoWizard from './FNOLNonAutoWizard';
import FNOLNonAutoTypeOfIncidentPage from './pages/TypeOfIncident/TypeOfIncidentPage';
/*import FNOLFireDamagePage from './pages/FireDamage/FireDamagePage';
import FNOLWaterDamagePage from './pages/WaterDamage/WaterDamagePage';
import FNOLCriminalDamagePage from './pages/CriminalDamage/CriminalDamagePage';
import FNOLOtherDamagePage from './pages/OtherDamage/OtherDamagePage';*/
//import FNOLNonAutoIncidentHoDetailsPage from './pages/hoDetails/HoDetailsPage';

setComponentMapOverrides(
    {
        FNOLNonAutoWizard: { component: 'FNOLNonAutoWizard' },
        FNOLNonAutoTypeOfIncidentPage: { component: 'FNOLNonAutoTypeOfIncidentPage' }
        /*,
        FNOLFireDamagePage: { component: 'FNOLFireDamagePage' },
        FNOLWaterDamagePage: { component: 'FNOLWaterDamagePage' },
        FNOLCriminalDamagePage: { component: 'FNOLCriminalDamagePage' },
        FNOLOtherDamagePage: {comopnent: 'FNOLOtherDamagePage'}*/
    },
    {
        FNOLNonAutoWizard,
        FNOLNonAutoTypeOfIncidentPage
        /*,
        FNOLFireDamagePage,
        FNOLWaterDamagePage,
        FNOLCriminalDamagePage,
        FNOLOtherDamagePage*/
    }
);

export {
    FNOLNonAutoWizard as default
};
